import { DayPilot, DayPilotSchedulerComponent } from "daypilot-pro-angular";
import { ContextMenuHelper } from "./context-menu-helper.service";
import { Injectable } from "@angular/core";
import { LiveFlightEvent } from "../../model/liveflight-event";

@Injectable()
export class SchedulerUpperHelper{
  constructor(private readonly contextMenuHelper: ContextMenuHelper) {
  }

  setupGeneralConfig(config: DayPilot.SchedulerConfig) {

    config.timeHeaders = [
      { groupBy: "Day", format: "dddd, d MMMM yyyy" },
      { groupBy: "Hour" },
      { groupBy: "Cell", format: "mm" }
    ];

    config.locale = "sv-se";
    config.eventTapAndHoldHandling = "ContextMenu";
    config.contextMenu = this.contextMenuHelper.contextMenu;
    config.dynamicEventRendering = "Disabled";
    config.eventResizingStartEndEnabled = true;
    config.showNonBusiness = true;
    config.allowEventOverlap = true;
    config.autoScroll = "Disabled";
    config.businessBeginsHour = 0;
    config.businessEndsHour = 24;
    config.businessWeekends = true;
    config.cellDuration = 10;
    config.dragOutAllowed = false;
    config.scale = "Manual";
    config.timeline = [];
    config.days = 1;    
    config.heightSpec = "Auto";
    config.height = 450;
    config.startDate = new DayPilot.Date();
    config.sortDirections = ["desc", "asc"];
    config.treeEnabled = true;
    config.rowHeaderWidthAutoFit = false;
    config.rowHeaderWidth = 210;
    config.separators = [{ color: "red", layer: "AboveEvents", location: new DayPilot.Date() }];
    config.snapToGrid = false;
    config.eventMovingStartEndEnabled = true;
    config.useEventBoxes = 'Never';
    config.crosshairType = 'Full';
    config.resources = [];
    config.rowDragHandleWidth = 20;
    config.rowMoveHandling = "Update";
    config.resourceExpandHandling = "CallBack";
    config.timeRangeRightClickHandling = "Disabled";

  }

  hideMenu() {
    this.contextMenuHelper.hideMenu();
  }

  async createContextMenu(args: DayPilot.SchedulerEventRightClickArgs, liveFlightEvents: LiveFlightEvent[], schedulerUpper: DayPilotSchedulerComponent) {
    await this.contextMenuHelper.createContextMenu(args, liveFlightEvents, schedulerUpper);
  };

  public parseTime(startDate: DayPilot.Date, startTime: string): Date {
    let d = startDate.toDateLocal();
    let time = /(\d+)(?::(\d\d))?\s*(p?)/.exec(startTime);
    d.setHours(parseInt(time[1]) + (time[3] ? 12 : 0));
    d.setMinutes(parseInt(time[2]) || 0);
    return d;
  }

  public diff_minutes(dt2: Date, dt1: Date) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  public toDayPilotDate(date: Date) {
    return new DayPilot.Date(date, true);
  }

}
